<template>
  <section>
    <h1 class="text-h3 mb-8">
      Expansion panels
    </h1>
    <v-sheet
      class="mb-4 px-6 py-4"
      outlined
      rounded
    >
      <div class="d-flex justify-space-between">
        <v-checkbox
          v-model="accordion"
          label="Accordion"
        />
        <v-checkbox
          v-model="disabled"
          label="Disabled"
        />
        <v-checkbox
          v-model="focusable"
          label="Focusable"
        />
        <v-checkbox
          v-model="inset"
          label="Inset"
        />
        <v-checkbox
          v-model="multiple"
          label="Multiple"
        />
        <v-checkbox
          v-model="popout"
          label="Popout"
        />
        <v-checkbox
          v-model="readonly"
          label="Readonly"
        />
      </div>
      <code>
        Value: {{ value }}
      </code>
      <v-expansion-panels
        v-model="value"
        class="mt-4"
        :accordion="accordion"
        :disabled="disabled"
        :focusable="focusable"
        :inset="inset"
        :multiple="multiple"
        :popout="popout"
        :readonly="readonly"
      >
        <v-expansion-panel
          v-for="(item,i) in 5"
          :key="i"
        >
          <v-expansion-panel-header>
            Item
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-sheet>
    <h2 class="text-h4 mb-4">
      Further reading
    </h2>
    <external-link href="https://vuetifyjs.com/en/components/expansion-panels/">
      <strong>Expansion panels</strong>
    </external-link>
  </section>
</template>

<script>
export default {
  name: 'ComponentsExpansionPanels',
  data: () => ({
    accordion: false,
    disabled: false,
    focusable: false,
    inset: false,
    multiple: false,
    popout: false,
    readonly: false,
    value: 1
  })
}
</script>
